module.exports = __webpack_public_path__ + "img/cloudNoData.cc7557b7.png";